export enum JxtStarSizeEnum {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
}

export enum JxtStarTypeEnum {
  Filled = 'Filled',
  Light = 'Light',
}

export interface IJxtStar {
  checked: boolean;
  disabled: boolean;
  type: JxtStarTypeEnum;
  size: JxtStarSizeEnum;
  /**
   * Return the pending request so the star keeps its optimistic state until it settles,
   * then falls back to `checked` (the server value, or the previous one on failure).
   */
  onClick?: (checked: boolean) => void | Promise<unknown>;
}
